// AUTO-GENERATED from weborder.json (OpenAPI). Do not edit by hand.
// Domain: payment
// Regenerate via scripts/gen-dtos.py

/**
 * Request body shared by the payment initiate and confirm endpoints. The
 * `paymentId` field carries a Stripe payment-method ID (`pm_…`) on
 * `/initiate` and a Stripe payment-intent ID (`pi_…`) on `/confirm` and
 * `/status`.
 */
export class PaymentRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.paymentId = raw.paymentId ?? ""; // Stripe identifier for the request. Pass the payment-method ID (`pm_…`) when calling `/init...
    /** @type {number} */
    this.submissionId = raw.submissionId ?? 0; // Submission id owned by the authenticated insured.
  }
}

/**
 * Payment Gateway payment intent details returned after initiation.
 */
export class PaymentInitiateResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.paymentIntentId = raw.paymentIntentId ?? ""; // Payment Gateway payment intent id.
    /** @type {string} */
    this.clientSecret = raw.clientSecret ?? ""; // Stripe client secret used by the frontend to complete payment confirmation.
    /** @type {string} */
    this.status = raw.status ?? ""; // Current payment intent status.
  }
}

/**
 * Payment Gateway status for a payment intent.
 */
export class PaymentStatusResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.paymentIntentId = raw.paymentIntentId ?? ""; // Payment Gateway payment intent id.
    /** @type {string} */
    this.status = raw.status ?? ""; // Current payment status.
    /** @type {string} */
    this.failureCode = raw.failureCode ?? ""; // Gateway failure code when payment fails.
    /** @type {string} */
    this.failureMessage = raw.failureMessage ?? ""; // Gateway failure message when payment fails.
  }
}

/**
 * Request to create a hosted Stripe Checkout session for a web order
 * submission.
 */
export class PaymentCheckoutRequest {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {number} */
    this.submissionId = raw.submissionId ?? 0; // Submission id owned by the authenticated insured.
    /** @type {string} */
    this.successUrl = raw.successUrl ?? ""; // Absolute HTTP(S) URL where Stripe redirects after successful checkout.
    /** @type {string} */
    this.cancelUrl = raw.cancelUrl ?? ""; // Absolute HTTP(S) URL where Stripe redirects when checkout is cancelled.
  }
}

/**
 * Hosted checkout session details returned by the Payment Gateway.
 */
export class PaymentCheckoutResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.paymentUrl = raw.paymentUrl ?? ""; // Stripe Checkout redirect URL.
  }
}

/**
 * Stripe publishable key configuration for the web order frontend.
 */
export class PaymentPublishableKeyResponse {
  /** @param {object} [raw] */
  constructor(raw = {}) {
    /** @type {string} */
    this.publishableKey = raw.publishableKey ?? ""; // Stripe publishable key.
  }
}
